import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <CTA data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}